import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article22() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article21');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article21');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };
  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article22-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article22-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="mb-4 mb-sm-5" ref={firstContainer}>
              <h3 className="mb-1 f-lora-i lh-base">Your essential guide to </h3>
              <h1 className="fs-xl f-lora mb-4 mb-sm-5">Up Helly Aa</h1>
              <h4 className="mb-4 mb-sm-5 f-lora-i lh-base">If you’re looking to experience a wild northern winter, punctuated with a dash of culture, fire and Viking tradition, then Up Helly Aa is an unmissable experience in Shetland’s cultural calendar. Laurie Goodlad explains the best way to make the most of Shetland’s festival of fire. </h4>
              <img className="img-fluid mb-4"
                src={require("../../Images/article22-right-img1.jpg")}
              />
              <img className="img-fluid mb-4"
                src={require("../../Images/article22-right-img2.jpg")}
              />
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <p className="">With no more than six hours of daylight throughout January, Shetland is a land of winter darkness. It’s an island hammered by Atlantic storms, fierce winds and biting cold, but within this, Up Helly Aa is the event longanticipated throughout the year which lights up the night sky and warms the hearts of thousands of participants and onlookers every year. </p>
                  <p className="">Between January and March, the islands celebrate the festival of Up Helly Aa, with 12 Fire Festival and Up Helly Aa celebrations featuring fiery processions, Viking dress and all-night parties following the burning of a Viking longship. Of these, the largest and most well-known is the Lerwick Up Helly Aa, which takes place on the last Tuesday of January. </p>
                  <p className="">Up Helly Aa’s roots can be found in the 19th-century tradition of ‘tar-barrelling’, a practice, eventually outlawed, which saw the town’s young men rolling burning barrels of tar through the narrow streets of Lerwick throughout the 24-day festival of Yule. </p>
                  <p className="">Up Helly Aa is not an ancient festival from Viking and Norse times but a celebration with its roots firmly embedded in Victorian Shetland, and like any proper Victorian soiree, theatrical pomp and ceremony were, and still do, flow unbridled. </p>
                </div>
                <div className="col-sm-6">
                  <p className="">Lerwick Up Helly Aa’s festivities last for 24 hours, attracting thousands of visitors each year from across the globe. A torchlit procession, led by the Guizer Jarl (chief Viking), weaves its way around the streets of Lerwick with over 1,000 people carrying burning torches. Following the parade, the guizers or squads (as participants are known) throw their burning torches into a replica Viking longship and sing the Norseman’s Home. The atmosphere during the procession is electric as street lights are extinguished, and spellbound spectators throng the streets, jostling for the best view. As the town glows under the light of the burning torches, the smell of paraffin and smoke permeates everything, as the rousing cheers echo around the buildings into the cold night sky. </p>
                  <p className="">After the ceremonial burning, a night of celebration commences as around a dozen public halls open their doors to welcome the squads (or groups) of guizers who perform a sketch or dance for the crowds. These are private, ticketed parties, and those attending must get an invite from one of the venue’s hosts or hostesses who organise the after-party. With impressive spreads of soup, sandwiches and home bakes, everyone remains wellfuelled, ensuring they can dance right into the next day. </p>
                  <p className="">During these 24 hours, Lerwick’s rule is handed over by the police to the Guizer Jarl, and the Town Hall proudly flies the Raven Banner flag. </p>
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6 py-1 py-md-5">
                  <div className="pe-0 pe-sm-4 mb-4 mb-sm-0">
                    <h4 className="mb-3 f-lora text-purple">Top tips for enjoying Lerwick Up Helly Aa </h4>
                    <p className="">Book ahead. Up Helly Aa is a popular event, with accommodation booking up sometimes years in advance and travel to the islands limited. You can get to Shetland by overnight ferry from Aberdeen (www.northlink.co.uk) or fly from most Scottish airports with Loganair (www.loganair.co.uk). </p>
                    <p className="">Bring warm clothing and waterproofs as the procession is often cold, wet and windy – but the effort to watch it is well worth it! </p>
                    <p className="">Arrive early to the procession to ensure that you get a good viewing point. Attend the Junior procession for better views with less people. </p>
                    <p className="">The day after Up Helly Aa is a public holiday so you may want to stock up on food supplies beforehand. </p>
                    <p className="">Check what else is on around Up Helly Aa, including pop-up markets and musical concerts. </p>

                    <h4 className="mb-3 f-lora text-purple">What to expect on the day </h4>
                    <p className="">Lerwick takes on a whole new character on Up Helly Aa day, and with a real festival feel buzzing around the town, the atmosphere is electric. </p>
                    <p className="">The Jarl Squad Timetable (available online at www.uphellyaa.org) provides all the key timings for the event. Check this before you attend so that you can make the most of the day and know where to see them and when. </p>
                    <p className="mb-0">Check out the Up Helly Aa Bill at the Market Cross for a tongue-in-cheek, satirical look at events in the community over the past year. The Bill is available from 6 am on Tuesday until 5 pm. </p>
                  </div>
                </div>
                <div className="col-sm-6 article22-bg">
                  <div className="p-3 p-xl-4 py-5 py-xl-5">
                    <h4 className="mb-4 mb-sm-5 f-lora text-purple">Timings </h4>
                    <h4 className="mb-2 f-lora text-purple">0900 </h4>
                    <p className="text-white mb-4">Muster at the Lerwick Legion and follow the Jarl Squad towards the Esplanade in the centre of town with the galley. The galley remains here, beside the Bressay Ferry Terminal, until 6 pm. </p>

                    <h4 className="mb-2 f-lora text-purple">1500 </h4>
                    <p className="text-white mb-4">Jarl Squad visit Shetland Museum & Archives. Book a ticket online at www.shetlandmuseumandarchives.org.uk. </p>

                    <h4 className="mb-2 f-lora text-purple">1730 </h4>
                    <p className="text-white mb-4">Attend the Junior Procession before the main parade. Fewer people turn out for this, so you’re assured a good view of proceedings and plenty of photo opportunities. </p>

                    <h4 className="mb-2 f-lora text-purple">1930 </h4>
                    <p className="text-white mb-4">Main procession, torchbearers begin at the Hillhead. </p>
                    <p className="text-white mb-4">After-party tickets: Hall tickets/invites are generally reserved for locals; however, they can sometimes be sourced. If you are looking for tickets for the halls, contact the Tourist Office for information, or keep an eye on the local press as tickets become available throughout the day. </p>
                    <p className="text-white mb-0">You DO NOT need a ticket/invite to attend the procession, only the after-parties. </p>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </motion.div>

      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        {/* <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button> */}
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article22;
